import { useMemo } from 'react'
import classes from '../index.module.scss'

export const BottomPath = ({
  size,
  pathSmallRatio,
  backgroundPathOuterRadius,
  bottomPathFill,
  bottomPathStroke,
  bottomPathStrokeWidth,
  bottomPathText,
  isBottomPathSmall,
}) => {
  const getSize = useMemo(() => {
    return size - backgroundPathOuterRadius * 2
  }, [size, backgroundPathOuterRadius])

  const getHeight = useMemo(() => {
    if (isBottomPathSmall) {
      return getSize * 0.5 * pathSmallRatio
    } else {
      return getSize * (0.5 + 0.5 * (1 - pathSmallRatio))
    }
  }, [getSize, pathSmallRatio, isBottomPathSmall])

  const getCyCirclePath = useMemo(() => {
    const cy = (getSize / 2) * (1 - pathSmallRatio)
    return isBottomPathSmall ? 0 - cy : cy
  }, [getSize, pathSmallRatio, isBottomPathSmall])

  return (
    <svg
      style={{
        width: getSize,
        height: getHeight,
        top: getSize - getHeight * pathSmallRatio + backgroundPathOuterRadius,
        transform: `translate(-50%, -${(1 - pathSmallRatio) * 100}%)`,
      }}
      className={classes.bottomPathSvg}
    >
      {/* Border */}
      <circle
        cx={getSize / 2}
        cy={getCyCirclePath}
        r={getSize / 2}
        fill={bottomPathStroke}
      />

      {/* Content */}
      <circle
        cx={getSize / 2}
        cy={getCyCirclePath}
        r={getSize / 2 - bottomPathStrokeWidth}
        fill={bottomPathFill}
      />
      <foreignObject x={0} y={0} width={getSize} height={getHeight}>
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '100%',
              textAlign: 'center',
            }}
            className={classes.textContainer}
          >
            {bottomPathText}
          </div>
        </div>
      </foreignObject>
    </svg>
  )
}
